/* PMT search modal (NSL-004 v2) — <pmt-search-modal>.
   Fixed top strip + dimmed overlay (Figma 10017:988 / 10017:1008). Opened by
   any [data-pmt-search-open] trigger via the pmt-search:open event (the pill
   and the icon buttons are the same trigger, differently styled). Owns focus
   trap, restore, Esc/overlay/✕ close, scroll lock with scrollbar
   compensation, and an inert background while open. */
(function () {
  'use strict';

  var TRANSITION_MS = 250;

  class PmtSearchModal extends HTMLElement {
    connectedCallback() {
      if (this._pmtInit) return;
      this._pmtInit = true;

      this.dialog = this.querySelector('[data-pmt-search-modal-dialog]');
      this.overlay = this.querySelector('[data-pmt-search-modal-overlay]');
      this.closeButton = this.querySelector('[data-pmt-search-modal-close]');
      this.input = this.querySelector('input[type="search"]');
      this._lastFocus = null;
      this._ac = new AbortController();
      var signal = this._ac.signal;

      if (!this.dialog) return;

      document.addEventListener(
        'pmt-search:open',
        function (event) {
          this.open(event.detail && event.detail.trigger);
        }.bind(this),
        { signal }
      );

      this.closeButton.addEventListener('click', this.close.bind(this), { signal });
      this.overlay.addEventListener('click', this.close.bind(this), { signal });

      this.dialog.addEventListener(
        'keydown',
        function (event) {
          if (event.key === 'Escape') {
            event.stopPropagation();
            this.close();
          } else if (event.key === 'Tab') {
            this.trapTab(event);
          }
        }.bind(this),
        { signal }
      );
    }

    disconnectedCallback() {
      if (this._ac) this._ac.abort();
      if (this.isOpen()) this.closeNow();
      /* allow connectedCallback to re-wire if the same node is reattached
         (e.g. a theme editor section move) after the abort above */
      this._pmtInit = false;
    }

    isOpen() {
      return this.dialog.hasAttribute('data-pmt-open');
    }

    open(trigger) {
      if (this.isOpen()) {
        if (this.input) this.input.focus();
        return;
      }
      this._lastFocus = trigger || document.activeElement;
      this.dialog.removeAttribute('hidden');
      document.documentElement.setAttribute('data-pmt-search-lock', '');
      document.body.setAttribute('data-pmt-search-open', '');
      PmtSearchModal.toggleInert(true, this);
      PmtSearchModal.setAppBarsLowered(true);
      /* double rAF so the slide-down transition runs after unhide */
      requestAnimationFrame(
        function () {
          requestAnimationFrame(
            function () {
              this.dialog.setAttribute('data-pmt-open', '');
            }.bind(this)
          );
        }.bind(this)
      );
      if (this.input) this.input.focus();
    }

    close() {
      if (!this.isOpen()) return;
      this.dialog.removeAttribute('data-pmt-open');
      document.documentElement.removeAttribute('data-pmt-search-lock');
      document.body.removeAttribute('data-pmt-search-open');
      PmtSearchModal.toggleInert(false, this);
      PmtSearchModal.setAppBarsLowered(false);
      setTimeout(
        function () {
          this.dialog.setAttribute('hidden', '');
        }.bind(this),
        TRANSITION_MS
      );
      if (this._lastFocus && this._lastFocus.focus) this._lastFocus.focus();
    }

    closeNow() {
      this.dialog.removeAttribute('data-pmt-open');
      this.dialog.setAttribute('hidden', '');
      document.documentElement.removeAttribute('data-pmt-search-lock');
      document.body.removeAttribute('data-pmt-search-open');
      PmtSearchModal.toggleInert(false, this);
      PmtSearchModal.setAppBarsLowered(false);
    }

    trapTab(event) {
      var focusables = this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* Inert background: everything in <body> except this element's section
       group and non-content tags. Attribute-only, reverted on close. */
    static toggleInert(on, modalElement) {
      if (!('inert' in HTMLElement.prototype)) return;
      Array.prototype.forEach.call(document.body.children, function (child) {
        if (child === modalElement.closest('.shopify-section-group-header-group')) return;
        if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE' || child.tagName === 'NOSCRIPT' || child.tagName === 'LINK' || child.tagName === 'TEMPLATE') return;
        if (on) {
          if (!child.hasAttribute('inert')) child.setAttribute('data-pmt-was-not-inert', '');
          child.setAttribute('inert', '');
        } else if (child.hasAttribute('data-pmt-was-not-inert')) {
          child.removeAttribute('inert');
          child.removeAttribute('data-pmt-was-not-inert');
        }
      });
    }

    static setAppBarsLowered(lowered) {
      try {
        var epb = document.getElementById('epb_container') || document.querySelector('[id*="epb_"]');
        if (epb) {
          if (lowered) {
            epb.style.setProperty('z-index', '1', 'important');
            epb.style.setProperty('pointer-events', 'none', 'important');
          } else {
            epb.style.removeProperty('z-index');
            epb.style.removeProperty('pointer-events');
          }
        }
        var bar =
          document.querySelector('.section-pmt-announcement-bar-v2') ||
          document.querySelector('.section-pmt-announcement-bar');
        if (bar) {
          if (lowered) {
            bar.style.setProperty('z-index', '1', 'important');
          } else {
            bar.style.removeProperty('z-index');
          }
        }
      } catch (e) {}
    }
  }

  if (!customElements.get('pmt-search-modal')) {
    customElements.define('pmt-search-modal', PmtSearchModal);
  }
})();
